import { Suspense, lazy } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { AmbientMotionProvider } from "./components/AmbientMotion"
import { MainLayout } from "./components/MainLayout"
import { PostSkeleton } from "./components/PostSkeleton"
import { SkyClockProvider } from "./components/SkyClock"
import { HomePage } from "./pages/HomePage"
import { NotFound } from "./pages/NotFound"

const BlogPost = lazy(() => import("./pages/BlogPost"))
// Throwaway state workbench for the top sky; dev builds only.
const SkyStates = import.meta.env.DEV ? lazy(() => import("./states/sky/SkyStates")) : null

export function App() {
  return (
    <AmbientMotionProvider>
      <BrowserRouter>
        <Routes>
          {SkyStates && (
            <Route
              path="/states/sky"
              element={
                <Suspense fallback={null}>
                  <SkyStates />
                </Suspense>
              }
            >
              <Route index element={<HomePage />} />
            </Route>
          )}
          <Route
            path="/"
            element={
              <SkyClockProvider>
                <MainLayout />
              </SkyClockProvider>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="blog/:slug" element={
              <Suspense fallback={<PostSkeleton />}>
                <BlogPost />
              </Suspense>
            } />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AmbientMotionProvider>
  )
}
